var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('article',{staticClass:"blocks blocks--content"},_vm._l((_vm.blocks),function(block){return _c(_vm.blockName(block.type),{tag:"component",attrs:{"content":block.content,"options":block.options}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }